import styled from 'styled-components';
import xeroIcon from '~/assets/public/xero-icon.png';

const XeroGrey = styled.img.attrs({ src: xeroIcon })`
  width: 1rem;
  height: 1rem;
  filter: grayscale(100%);
  opacity: 0.6;
`;

export default XeroGrey;
